if (!customElements.get('product-video-autoplay')) {
  class ProductVideoAutoplay extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.externalContainer = this.querySelector('.product-video-autoplay__external');

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.5 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.play();
      } else {
        this.pause();
      }
    }

    play() {
      if (this.video) {
        this.video.play().catch(() => {});
        return;
      }

      if (this.externalContainer && !this.externalContainer.firstChild) {
        const iframe = document.createElement('iframe');
        iframe.src = this.externalContainer.dataset.src;
        iframe.title = 'Product video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        this.externalContainer.appendChild(iframe);
      }
    }

    pause() {
      if (this.video) {
        this.video.pause();
        return;
      }

      if (this.externalContainer) {
        this.externalContainer.innerHTML = '';
      }
    }
  }

  customElements.define('product-video-autoplay', ProductVideoAutoplay);
}
